/** zh-CN catalogue `checkerStyle` (W3-09; English: src/features/checker/rules/style.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'checkerStyle',
  locale: 'zh-CN',
  messages: {
    st01Title: '时间设置未确认',
    st02Title: '占位曲绘',
    st03Title: '未使用的文件',
    st04Title: '空判定线',
    st05Title: '连续过长的直线区段',
    st06Title: '自定义音符（RPE“其他”类提醒）',
    st07Title: 'MP3 曲目',
    st08Title: 'FLAC 曲目',
    st09Title: '谱面信息不完整',
    st01What: '速度（{bpm} BPM）和偏移（{offset} 毫秒）尚未确认。',
    st01Why:
      '每个音符都位于节拍网格上。如果速度或偏移稍有偏差，所有音符在 Phira 中都会显得偏早或偏晚，之后再修正会移动所有音符。',
    fixOpenTiming: '打开“曲目与时间”',
    fixConfirmTiming: '时间设置正确',
    st02What: '曲绘是自动生成的占位图。',
    st02Why: '玩家会在曲目列表中看到曲绘，谱面背后也会显示模糊的曲绘；使用自己的图片能让谱面更容易辨认。',
    fixChoosePicture: '选择图片…',
    st03What: '谱面没有使用“{path}”。',
    st03Why: '未使用的文件会让谱面包的下载体积变大；Phira 永远不会显示或播放它们。',
    fixRemoveFile: '移除“{path}”',
    fixRemoveAllFiles: '{count, plural, other {移除全部 # 个未使用的文件}}',
    st04What: '{line} 没有音符，并且始终不可见。',
    st04Why: '它的不透明度从未高于 0，因此在 Phira 中不会绘制任何内容，只会让判定线列表变长。',
    st04WhatStill: '{line} 没有音符，并且从不运动。',
    st04WhyStill: 'Phira 从头到尾都把它画成同一条普通的线。如果它不是用作装饰，只会遮挡屏幕并让判定线列表变长。',
    fixDeleteLine: '删除 {line}',
    fixDeleteAllLines: '{count, plural, other {删除全部 # 条空判定线}}',
    fixShowLine: '显示该判定线',
    st05What:
      '{line} 的{prop, select, alpha {不透明度} moveX {X 位置} moveY {Y 位置} rotate {旋转} speed {流速} scaleX {X 尺寸} scaleY {Y 尺寸} other {某个属性}}上连续有 {count} 个直线区段（{from} 到 {to}）。',
    st05Why: '连续的短直线分段通常来自烘焙。它们会让谱面变大且难以编辑；用几个带缓动的区段通常效果相同。',
    fixRemoveRedundant: '{count, plural, other {移除 # 个不影响运动的关键帧}}',
    fixSelectKeys: '{count, plural, other {选中 # 个关键帧}}',
    st06WhatSize: '{line} 上有 {count, plural, other {# 个音符}}使用了自定义宽度。',
    st06WhatFake: '{line} 上有 {count, plural, other {# 个音符}}是装饰（假）音符。',
    st06WhatVisible: '{line} 上有 {count, plural, other {# 个音符}}使用了自定义出现时间。',
    st06WhySize: '玩家习惯通常宽度的音符；RPE 会将自定义宽度列为提醒。',
    st06WhyFake: '装饰（假）音符永远不会被判定；请确保玩家能把它们与真音符区分开。',
    st06WhyVisible: '出现得晚的音符很难读；RPE 会将自定义出现时间列为提醒。',
    fixSelectNotes: '{count, plural, other {选中 # 个音符}}',
    st07What: '曲目“{path}”是 MP3 文件。',
    st07Why:
      'MP3 解码器会加入一小段延迟，且不同播放器和浏览器的延迟不同，因此这里看起来正确的时间在 Phira 中可能偏差几毫秒。OGG 或 WAV 能保持时间精确。',
    st08What: '曲目“{path}”是 FLAC 文件。',
    st08Why: 'Phira 能播放 FLAC，但 RPE 无法打开它；如果你或合作谱师要在 RPE 中编辑谱面，请转换格式。',
    fixConvertToWav: '转换为 WAV',
    fixChooseSong: '选择其他文件…',
    st09What:
      '{field, select, name {曲名} composer {曲师} charter {谱师} illustrator {画师} level {难度标签} other {某项信息}}{state, select, empty {为空} other {仍为“UK”（未知）}}。',
    st09Why: '玩家会在曲目列表中看到这些信息，Phira 分享谱面时也会显示它们。',
    st09WhatDivision: '谱面没有分区标签（regular、troll、plain 或 visual）。',
    st09WhyDivision: 'Phira 的上传表单会把每张谱面归入其中一个分区。',
    fixTagRegular: '标记为“regular”',
    fixEditDetail:
      '{field, select, name {编辑曲名} composer {编辑曲师} charter {编辑谱师} illustrator {编辑画师} level {编辑难度标签} other {编辑信息}}',
    fixEditTags: '选择分区',
  },
};

export default catalog;
